import clsx from "clsx";

import styles from "./loader.module.css";

interface LoaderProps {
  "data-testid"?: string;
  className?: string;
  type?: "inline" | "page";
}

function Loader({
  type = "inline",
  "data-testid": testId = "pallet-loader",
  className,
}: LoaderProps) {
  const loader = (
    <div
      data-testid={testId}
      data-test-role="loader"
      className={clsx(styles.loader, className)}
    ></div>
  );

  if (type === "inline") {
    return loader;
  } else {
    return <div className={styles.page}>{loader}</div>;
  }
}

export default Loader;
